// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__mVvOv","active":"Pagination_active__q3h4d","list":"Pagination_list__hQ041","button":"Pagination_button__toUqU"};